export const formatConsultationDate = (consultation) => {
    const isoDate = consultation.modified || consultation.created;
    if (!isoDate) {
        return '-';
    }
    const date = new Date(isoDate);
    const formatter = new Intl.DateTimeFormat('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true, // use AM/PM
    });
    const formattedDate = formatter.format(date);
    return formattedDate;
};
